<template>
  <div>
    <headerNav title="设置" />
    <div class="smain">
      <div class="main-info">
        <div class="sheader">
          <div class="sheader-pic">
            <van-uploader
              :max-count="1"
              :after-read="afterRead"
              accept="image/*"
            >
              <img v-lazy="headimg" />
            </van-uploader>
          </div>
          <div class="sheader-info">
            <div>{{ userInfo.phoneNum }}</div>
            <div>昵称:{{ userInfo.dealerName }}</div>
            <div>推荐人数:{{ userInfo.referrerNum }}</div>
            <div v-if="userInfo.memberLevelStart">
              星级:<van-icon
                :color="$abctheme.basecolor"
                :size="14"
                v-for="index in userInfo.memberLevelStart.level"
                :key="index"
                name="star"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="main-brand">
        <div>品牌：群婴汇</div>
      </div>

      <div style="margin-bottom:10px;">
       <van-field
          v-model="userInfo.wxNumber"
          center
          clearable
          label="微信号"
          placeholder="请输入微信号"
        >
          <template #button>
            <van-button size="small" @click="updatemyinfo" type="primary">修改</van-button>
          </template>
       </van-field>
      </div>

      <div style="margin-bottom:10px;">
        <van-field
            v-model="userInfo.cardNumber"
            center
            clearable
            label="身份证号"
            placeholder="请输入身份证号"
          >
            <template #button>
              <van-button size="small" @click="updatemycard" type="primary">修改</van-button>
            </template>
        </van-field>
      </div>

      <div class="main-info">
        <div class="main-info-data">
          <div>
            <span>推荐人</span>
            <span class="span-right">{{
              userInfo.referrerName ? userInfo.referrerName : "公司"
            }}</span>
          </div>
          <div>
            <span>上级</span>
            <span class="span-right">{{
              userInfo.parentName ? userInfo.parentName : "公司"
            }}</span>
          </div>
          <div>
            <span>邀请人</span>
            <span class="span-right">{{
              userInfo.inviteName ? userInfo.inviteName : "无"
            }}</span>
          </div>
        </div>
      </div>
      <div class="main-info">
        <div class="main-info-list">
          <div @click="goto('/brank')">
            <span>修改账户银行卡信息</span>
            <van-icon
              class="span-right sicon"
              :size="fsize"
              :color="$abctheme.basecolor"
              class-prefix="abc-icon"
              name="you"
            />
          </div>
        </div>
      </div>
      <div class="main-info">
        <div class="main-info-list">
          <div @click="goto('/setaccountpwd')">
            <span>登录密码修改</span>
            <van-icon
              class="span-right sicon"
              :size="fsize"
              :color="$abctheme.basecolor"
              class-prefix="abc-icon"
              name="you"
            />
          </div>
          <div @click="goto('/setpwd')">
            <span>支付密码修改</span>
            <van-icon
              class="span-right sicon"
              :size="fsize"
              :color="$abctheme.basecolor"
              class-prefix="abc-icon"
              name="you"
            />
          </div>
        </div>
      </div>
      <div class="main-info">
        <div class="main-info-list" @click="goto('/user/address', 1)">
          <span>收货地址管理</span>
          <van-icon
            class="span-right sicon"
            :size="fsize"
            :color="$abctheme.basecolor"
            class-prefix="abc-icon"
            name="you"
          />
        </div>
      </div>
      <div class="main-info">
        <div class="main-info-list" @click="bindWx">
          <span>绑定微信账号</span>
          <van-icon
            class="span-right sicon"
            :size="fsize"
            :color="$abctheme.basecolor"
            class-prefix="abc-icon"
            name="you"
          />
        </div>
      </div>
      <div class="main-info">
        <div class="main-info-list" @click="goto('setmyqrcode')">
          <span>设置个人微信二维码</span>
          <van-icon
            class="span-right sicon"
            :size="fsize"
            :color="$abctheme.basecolor"
            class-prefix="abc-icon"
            name="you"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import AppConsts from '../../../config/appconst';
export default {
  data() {
    return {
      fsize: 18,
      fileList: [],
      userInfo: {},
      headimg:''
    };
  },
  created() {
      let b=localStorage.getItem("bindwx");
    if (b) {
      localStorage.setItem("bindwx", '');
      var code = this.getQueryVariable("code");
      if (code) {
        this.ajax
          .post("/api/TokenAuth/WxOAuthorization", { isBind: true,code:code })
          .then((x) => {
            location.href = "http://" + location.host + "/#/set";
            return;
          });
      }

      return;
    }

    this.queryuserinfo();
  },
  methods: {
    queryuserinfo() {
      this.ajax.post("/api/services/app/PhoneUser/QueryUserInfo").then((x) => {
        this.userInfo = x.result;
        this.abp.userInfo = x.result;
        this.headimg=this.setpic();
      });
    },
    updatemyinfo()
    {
      var data={
          wxNumber:this.userInfo.wxNumber
      }
      this.ajax.post('/api/services/app/PhoneUser/WxPramUpdateInfo',data).then(()=>
      {
          this.$toast.success("修改成功");
          this.abp.userInfo=this.userInfo;
      })
    },
    updatemycard()
    {
      var data={
          cardNumber:this.userInfo.cardNumber
      }
      this.ajax.post('/api/services/app/PhoneUser/WxPramUpdateCardNo',data).then(()=>
      {
          this.$toast.success("修改成功");
          this.abp.userInfo=this.userInfo;
      })
    },
    goto(url, state) {
      if (state) {
        this.$router.push({ path: url, query: { state: state } });
      } else {
        this.$router.push({ path: url });
      }
    },
    setpic() {
      var cururl = this.$baseurl;
      if (this.userInfo.headPic) {
          if(this.userInfo.headPic.indexOf('thirdwx.qlogo.cn')!=-1){
                    return  this.userInfo.headPic;
                }
        return cururl + this.userInfo.headPic;
      }
      if ( this.userInfo.memberLevelModel.imgPath) {
        return cururl + this.userInfo.memberLevelModel.imgPath;
      }
      return "../../assets/images/missing-face.png";
    },
    afterRead(file) {
      var formData = new FormData(); //构造一个 FormData，把后台需要发送的参数添加
      formData.append("file", file.file); //接口需要传的参数
      this.ajax
        .post("/api/services/app/PhoneUser/SaveMemberPic", formData)
        .then(() => {
          this.queryuserinfo();
        })
        .catch(() => {});
    },
    bindWx() {
      if (process.env.NODE_ENV == "production") {
        localStorage.setItem("bindwx", "1");
        location.href =
          "https://open.weixin.qq.com/connect/oauth2/authorize?appid="+AppConsts.wxappid+"&redirect_uri=http%3A%2F%2f" +
          location.host +
          "%2F%23%2Fset" +
          "&response_type=code&scope=snsapi_userinfo&state=123#wechat_redirect";
        console.log("https://open.weixin.qq.com/connect/oauth2/authorize?appid="+AppConsts.wxappid+"&redirect_uri=http%3A%2F%2f" +
          location.host +
          "%2F%23%2Fset" +
          "&response_type=code&scope=snsapi_userinfo&state=123#wechat_redirect");
      }

    },
  },
};
</script>
<style lang="scss" scoped>
.smain {
  font-size: 14px;
  margin: 10px;
  color: #949494;
}
.main-info {
  background-color: white;
  padding: 10px;
  border-radius: 4px;
  box-shadow: 1px 1px 4px #e0e0e0;
  margin-bottom: 15px;
}
.sheader {
  position: relative;
  padding-left: 100px;
  line-height: 20px;
  min-height: 80px;
}
.sheader-pic {
  position: absolute;
  left: 0;
  top: 50%;
  transform: translate(0, -50%);
  width: 80px;
  height: 80px;
  padding: 2px;
  border-radius: 50%;
  background-color: #fff;
}
.sheader-pic img {
  width: 80px;
  height: 80px;
  border-radius: 50%;
}
.main-brand {
  margin-bottom: 10px;
}

.main-info-data div {
  border-bottom: 0.1px solid #f3f3f3;
  padding: 10px 0;
}
.main-info-data div:first-child {
  padding-top: 0;
}
.main-info-data div:last-child {
  border: 0;
  padding-bottom: 0;
}
.span-right {
  float: right;
}
.main-info-list div {
  border-bottom: 0.1px solid #f3f3f3;
  padding: 10px 0;
}
.main-info-list div:first-child {
  padding-top: 0;
}
.main-info-list div:last-child {
  border: 0;
  padding-bottom: 0;
}
</style>
